import {
  MORE_ACTIONS_KEYS,
  ROUTES,
  TABLE_NAMES,
  VEHICLES_ACTIONS
} from "../../../../../shared";
import ExportResourceDialog from "../../dialogs/reusableDialogs/ExportResourceDialog/ExportResourceDialog";
import ImportResourceDialog from "../../dialogs/reusableDialogs/ImportResourceDialog/ImportResourceDialog";
import AddVehiclesDialog from "../../dialogs/vehicles/AddVehicleDialog/AddVehiclesDialog";
import { useDialog } from "../../hooks/useDialog";
import PageHeaderActions from "../PageHeaderActions";

const VehiclesHeaderActions = () => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  return (
    <PageHeaderActions
      route={ROUTES.Vehicles}
      openDialog={openDialog}
      addItem
      moreActions={[MORE_ACTIONS_KEYS.Import, MORE_ACTIONS_KEYS.Export]}
    >
      <AddVehiclesDialog
        isOpen={isDialogOpen[VEHICLES_ACTIONS.AddVehicle]}
        onClose={closeDialog}
      />

      <ImportResourceDialog
        route={ROUTES.Vehicles}
        tableName={TABLE_NAMES.Vehicles}
        isOpen={isDialogOpen[VEHICLES_ACTIONS.ImportVehicle]}
        onClose={closeDialog}
      />

      <ExportResourceDialog
        route={ROUTES.Vehicles}
        tableName={TABLE_NAMES.Vehicles}
        isOpen={isDialogOpen[VEHICLES_ACTIONS.ExportVehicle]}
        onClose={closeDialog}
      />
    </PageHeaderActions>
  );
};

export default VehiclesHeaderActions;
